import { baseQueryWithLogout } from "@/lib/baseQuery";
import { getMediaUploadErrorMessage } from "@/lib/mediaUploadError";
import { createApi } from "@reduxjs/toolkit/query/react";
import toast from "react-hot-toast";
import { Media } from "./media.type";

export const MediaApi = createApi({
  reducerPath: "mediaApi",
  tagTypes: ["media"],
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    uploadMedia: build.mutation<Media, FormData>({
      query: (data) => {
        return {
          url: "media_objects",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["media"],
      // Every image upload goes through here: tell the user why the API
      // refused the file (wrong type, too large) instead of failing silently.
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          const error = (err as { error?: unknown } | undefined)?.error;
          if ((error as { status?: unknown } | undefined)?.status !== 401) {
            toast.error(getMediaUploadErrorMessage(error));
          }
        }
      },
    }),
  }),
});

export const { useUploadMediaMutation } = MediaApi;
